// extracted by mini-css-extract-plugin
export default {"main":"VPR_main__-5SYR"};